import { useState, useCallback } from "react";
import { getDanhGiaByLop, saveDanhGia, getDiemTBHocKy, getChuyenCanHocKy, getGoiYXepLoai } from "../services/DanhGiaService";
import { getHocSinhByLop } from "../services/hocSinhService";
import { useToast } from "../components/Toast/ToastContext";

export const useDanhGia = (lopId, hocKy, namHoc, userId) => {
  const toast = useToast();
  const [hocSinh, setHocSinh] = useState([]);
  const [danhGiaMap, setDanhGiaMap] = useState({});
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const loadData = useCallback(async () => {
    if (!lopId) return;
    setLoading(true);
    try {
      const [hsList, dgList] = await Promise.all([
        getHocSinhByLop(lopId),
        getDanhGiaByLop(lopId, hocKy),
      ]);
      
      // Sort: chưa đánh giá lên trước, rồi theo tên
      const dgMap = {};
      dgList.forEach(d => { dgMap[d.hocSinhId] = d; });
      
      hsList.sort((a, b) => {
        const aDone = !!dgMap[a.id];
        const bDone = !!dgMap[b.id];
        if (aDone !== bDone) return aDone ? 1 : -1;
        return (a.hoTen || "").split(" ").pop().toLowerCase().localeCompare((b.hoTen || "").split(" ").pop().toLowerCase());
      });
      
      setHocSinh(hsList);
      setDanhGiaMap(dgMap);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }, [lopId, hocKy]);

  const calculateForHS = useCallback(async (hsId) => {
    const [diemTB, ccData] = await Promise.all([
      getDiemTBHocKy(hsId, hocKy),
      getChuyenCanHocKy(hsId, lopId, hocKy),
    ]);
    const goiY = getGoiYXepLoai(diemTB, ccData.chuyenCan, ccData.vangKP);
    return { diemTB, ...ccData, goiY };
  }, [lopId, hocKy]);

  const save = useCallback(async (hsId, formData) => {
    setSaving(true);
    try {
      const data = {
        hocSinhId: hsId,
        lopId,
        hocKy,
        namHoc,
        ...formData,
        nguoiDanhGiaId: userId,
        ngayTao: new Date().toISOString(),
      };
      await saveDanhGia(data);
      
      // Update local map
      setDanhGiaMap(prev => ({
        ...prev,
        [hsId]: data,
      }));
      
      return { success: true };
    } catch (err) {
      toast.error("Lỗi lưu đánh giá: " + err.message);
      return { success: false };
    } finally {
      setSaving(false);
    }
  }, [lopId, hocKy, namHoc, userId, toast]);

  return {
    hocSinh,
    danhGiaMap,
    loading,
    saving,
    loadData,
    calculateForHS,
    save,
  };
};